import morphism from 'morphism';
import { requestModelCarrierHistoryDownload } from '../model/genericTransactionView';
import { API_BASE_URL } from '../globals';
import { GET, POST } from './apiHandler';
import {
  GET_THIRD_PARTY_RECON_LIST,
  GET_THIRD_PARTY_RECON_CN_LIST,
  CREATE_THIRD_PARTY_TRANSACTION,
  DOWNLOAD_THIRD_PARTY_RECON,
  DOWNLOAD_SAMPLE_THIRD_PARTY_RECON,
  DOWNLOAD_CARRIER_RECON_LIST,
  GET_CONSIGNMENT_BALANCE_LIST_THIRD_PARTY,
  DOWNLOAD_COURIER_ACCOUNT_TRANSACTION,
  RECONCILE_CARRIER_CN,
  FETCH_CN_CASH_BALANCE,
  SCAN_CARRIER_RECON_CN,
  REMOVE_CARRIER_CN_DRAFT,
  DOWNLOAD_CARRIER_CN_RECON_LIST,
  FETCH_CARRIER_CN_FROM_DRAFT,
} from './routes';

export const getThirdPartyReconList = async (params) => {
  return GET(`${API_BASE_URL}${GET_THIRD_PARTY_RECON_LIST}`, params);
};

export const getThirdPartyReconCnList = async (body) => {
  return POST(`${API_BASE_URL}${GET_THIRD_PARTY_RECON_CN_LIST}`, body);
};

export const createTransaction = async (body) => {
  return POST(`${API_BASE_URL}${CREATE_THIRD_PARTY_TRANSACTION}`, body);
};

export const downloadThirdPartyRecon = async (params) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_THIRD_PARTY_RECON}`, params);
};

export const downloadSampleThirdPartyRecon = async () => {
  return GET(`${API_BASE_URL}${DOWNLOAD_SAMPLE_THIRD_PARTY_RECON}`);
};

export const downloadCarrierReconList = async (params) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_CARRIER_RECON_LIST}`, params);
};

export const getConsignmentBalanceListThirdParty = async (body) => {
  return GET(
    `${API_BASE_URL}${GET_CONSIGNMENT_BALANCE_LIST_THIRD_PARTY}`,
    body,
  );
};

export const downloadCourierAccountTransaction = async (body) => {
  const params = {
    ...morphism(requestModelCarrierHistoryDownload, body),
  };
  return POST(`${API_BASE_URL}${DOWNLOAD_COURIER_ACCOUNT_TRANSACTION}`, params);
};

export const reconcileCarrierCN = async (body) => {
  return POST(`${API_BASE_URL}${RECONCILE_CARRIER_CN}`, body);
};

export const fetchCnCashBalance = async (body) => {
  return POST(`${API_BASE_URL}${FETCH_CN_CASH_BALANCE}`, body);
};

export const scanItemForDraft = async (body) => {
  return POST(`${API_BASE_URL}${SCAN_CARRIER_RECON_CN}`, body);
};

export const removeItemFromDraft = async (body) => {
  return POST(`${API_BASE_URL}${REMOVE_CARRIER_CN_DRAFT}`, body);
};

export const downloadCnBalance = async (body) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_CARRIER_CN_RECON_LIST}`, body);
};

export const fetchCnDraft = async (body) => {
  return GET(`${API_BASE_URL}${FETCH_CARRIER_CN_FROM_DRAFT}`, body);
};
